export let ProgressRootDataAttributes = /*#__PURE__*/function (ProgressRootDataAttributes) {
  ProgressRootDataAttributes["complete"] = "data-complete";
  ProgressRootDataAttributes["indeterminate"] = "data-indeterminate";
  ProgressRootDataAttributes["progressing"] = "data-progressing";
  return ProgressRootDataAttributes;
}({});